import axios from "axios";
import {PostCode, SelectedProduct, selectedProductData} from "./model/product";

const isProduction = process.env.NODE_ENV === 'production';

export const API_URL: string = isProduction
    ? 'https://ablack.ambience.kr:6161'
    : 'http://localhost:6161';

// 세션 데이터 받아오기
export const get_session = async () => {
    const url = `${API_URL}/customer/get_session_data`;
    let data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch(err) {
        console.log(err);
    }
}

// 로그인 요청
export const login_request = async (
    customerEmail:string,
    customerPassword:string
) => {
    const url = `${API_URL}/customer/login`;
    let data = new FormData();
    data.append('customerEmail', customerEmail);
    data.append('customerPassword', customerPassword);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch(err) {
        console.log(err);
    }
};

// 로그아웃
export const logout_request = async () => {
    const url = `${API_URL}/customer/logout`;
    let data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch(err) {
        console.log(err);
    }
};

// 고객사 정보 요약
export const get_customer_summary = async (
    customer_ID:string
) => {
    const url = `${API_URL}/customer/summary`;
    let data = new FormData();
    // blob형식의 데이터는 number를 담을 수가 없다고 함?
    data.append('customer_ID', customer_ID);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 고객 point 가져오기
export const get_customer_point = async (
    customer_ID:string
) => {
    const url = `${API_URL}/customer/get_customer_point`;
    let data = new FormData();
    data.append('customer_ID', customer_ID);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 브랜드 리스트 가져오기
export const get_brand_select = async () => {
    const url = `${API_URL}/reservation/select_brand`;
    let data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 커뮤니티 작성글이 있는 브랜드의 리스트만 가져오기
export const get_community_brand_select = async () => {
    const url = `${API_URL}/community/get_community_brand_select`;
    let data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 브랜드_ID로 제품 리스트 가져오기
export const get_product_select = async (
    brand_ID:string
) => {
    const url = `${API_URL}/reservation/get_product_select`;
    let data = new FormData();
    data.append('brand_ID', brand_ID);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 견적 금액 요청
export const get_estimate_price = async (
    estimate_division    : number,
    estimate_high_status : number,
    selected_product     : SelectedProduct[], // product_ID:number, quantity: number
    customer_ablack_rate : number,
    customer_address_1   : string,
    customer_address_2   : string,
    estimate_with_removal: number = 0,
) => {
    let list = [];
    for (let i = 0; i < selected_product.length; i++) {
        const obj = {
            product_ID : selected_product[i].product_ID,
            quantity   : selected_product[i].quantity
        };
        list.push(obj);
    };

    const url = `${API_URL}/reservation/get_estimate_price`;
    let data = new FormData();
    data.append('estimate_division', estimate_division.toString());
    data.append('estimate_with_removal', estimate_with_removal.toString());
    data.append('estimate_high_status', estimate_high_status.toString());
    data.append('selected_product', JSON.stringify(list));
    data.append('customer_ablack_rate', customer_ablack_rate.toString());
    data.append('customer_address_1', customer_address_1);
    data.append('customer_address_2', customer_address_2);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 휴무일 가져오기
export const get_ablack_holiday = async () => {
    const url = `${API_URL}/reservation/get_ablack_holiday`;
    let data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 모바일 메시지 전송 요청
export const send_message = async (
    phone_number  : string,
    message_style : number,
    message_data  : string,
) => {
    const url = `${API_URL}/common/send_message`;
    let data = new FormData();
    data.append('phone_number', phone_number);
    data.append('message_style', message_style.toString());
    data.append('message_data', message_data);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 예약 확인 등록
export const insert_reservation = async (
    primitive_data     : any,
    general_photo_list : File[],
    direct_photo_list  : File[],
    kakao_push_content: string,
) => {
    const url = `${API_URL}/reservation/insert_reservation`;
    let data = new FormData();
    data.append('primitive_data', JSON.stringify(primitive_data));
    data.append('kakao_push_content', kakao_push_content);
    general_photo_list.forEach(file => {
        data.append('general_photo_list', file);
    });
    direct_photo_list.forEach(file => {
        data.append('direct_photo_list', file);
    });
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        // 새 형식: {success: 1, construction_reservation_ID: xxx}
        // 또는 기존: 1
        // 또는 에러: {success: 0, error: 'ERROR_CODE'}
        return response.data;
    }
    catch (err) {
        console.log(err);
        return { success: 0, error: 'NETWORK_ERROR' };
    }
};

// 탈거+시공 동시 예약 등록 (탈거 1건 + 시공 1건 별도 생성, 결제 동시 미지원)
export const insert_reservation_with_removal = async (
    primitive_data     : any,
    general_photo_list : File[],
    direct_photo_list  : File[],
    kakao_push_content : string,
) => {
    const url = `${API_URL}/reservation/insert_reservation_with_removal`;
    let data = new FormData();
    data.append('primitive_data', JSON.stringify(primitive_data));
    data.append('kakao_push_content', kakao_push_content);
    general_photo_list.forEach(file => {
        data.append('general_photo_list', file);
    });
    direct_photo_list.forEach(file => {
        data.append('direct_photo_list', file);
    });
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        // 성공: 1, 실패: 2
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 포트폴리오 등록
export const insert_portfolio = async (
    ablack_comunity_customer_ID : number,
    ablack_comunity_brand_ID : number,
    ablack_comunity_color_ID : number,
    ablack_comunity_division : number,
    ablack_comunity_review   : string,
    portfolio_photo_list     : File[],
    ablack_comunity_high_status : number,
    ablack_comunity_construction_reservation_ID : number,
    ablack_comunity_square_meter : number,
    ablack_comunity_space : number,
) => {
    const url = `${API_URL}/community/insert_portfolio`;
    let data = new FormData();
    data.append('ablack_comunity_customer_ID', ablack_comunity_customer_ID.toString());
    data.append('ablack_comunity_brand_ID', ablack_comunity_brand_ID.toString());
    data.append('ablack_comunity_color_ID', ablack_comunity_color_ID.toString());
    data.append('ablack_comunity_division', ablack_comunity_division.toString());
    data.append('ablack_comunity_review', ablack_comunity_review);
    data.append('ablack_comunity_high_status', ablack_comunity_high_status.toString());
    data.append('ablack_comunity_construction_reservation_ID', ablack_comunity_construction_reservation_ID.toString());
    data.append('ablack_comunity_square_meter', ablack_comunity_square_meter.toString());
    data.append('ablack_comunity_space', ablack_comunity_space.toString());
    portfolio_photo_list.forEach(file => {
        data.append('portfolio_photo_list', file);
    });
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
}

// 예약 내역 리스트 요청
export const select_reservation_detail = async (
    customer_ID_use_construction_reservation : number,
    construction_reservation_progress        : number,
    list_count                               : number,
    page                                     : number,
    field                                    : number,
    order                                    : number
) => {
    let sort = "";
    if(order === 0) {
        sort = "DESC";
    } else if (order === 1) {
        sort = "ASC";
    }
    let str = "";
    switch (field) {
        case 0 : str = "construction_reservation_ID"; break;
        case 1 : str = "construction_reservation_progress"; break;
        case 2 : str = "construction_reservation_division"; break;
        case 3 : str = "construction_reservation_name"; break;
        case 4 : str = "construction_reservation_big_area"; break;
        case 5 : str = "construction_reservation_reservationTime"; break;
        case 6 : str = "construction_reservation_time"; break;
        case 7 : str = "construction_reservation_requests"; break;
        case 8 : str = "construction_reservation_point"; break;
        default : str = "construction_reservation_ID";
    };

    const url = `${API_URL}/reservation/select_reservation_detail`;
    let data = new FormData();
    data.append('customer_ID_use_construction_reservation', customer_ID_use_construction_reservation.toString());
    data.append('construction_reservation_progress', construction_reservation_progress.toString());
    data.append('list_count', list_count.toString());
    data.append('pagination', page.toString());
    data.append('field', str);
    data.append('order', sort);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 견적 장바구니 담기
export const insert_estimate = async (
    estimate_customer_ID          : number,
    estimate_division             : number,
    estimate_high_status          : number,
    estimate_selected_product     : selectedProductData[],
    estimate_customer_ablack_rate : number,
    estimate_customer_address1    : PostCode,
    estimate_customer_address2    : PostCode,
) => {
    const url = `${API_URL}/reservation/insert_estimate`;
    const data = new FormData();
    data.append('estimate_customer_ID', estimate_customer_ID.toString());
    data.append('estimate_division', estimate_division.toString());
    data.append('estimate_high_status', estimate_high_status.toString());
    data.append('estimate_selected_product', JSON.stringify(estimate_selected_product));
    data.append('estimate_customer_ablack_rate', estimate_customer_ablack_rate.toString());
    data.append('estimate_customer_address1', JSON.stringify(estimate_customer_address1));
    data.append('estimate_customer_address2', JSON.stringify(estimate_customer_address2));
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
};

// 견적 장바구니 리스트 가져오기 (그룹)
export const get_estimate = async (
    estimate_customer_ID : number,
    pagination           : number
) => {
    const url = `${API_URL}/reservation/select_cart_estimate`;
    const data = new FormData();
    data.append('estimate_customer_ID', estimate_customer_ID.toString());
    data.append('pagination', pagination.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 견적 장바구니 리스트 가져오기 (개별)
export const get_estimate_mono = async (
    estimate_customer_ID : number,
    pagination           : number,
    field                : number,
    order                : number,
) => {
    let sort = "";
    if(order === 0) {
        sort = "DESC";
    } else if (order === 1) {
        sort = "ASC";
    }
    let str = "";
    switch (field) {
        case 0 : str = "estimate_ID"; break;
        case 1 : str = "estimate_division"; break;
        case 2 : str = "estimate_brand_ID"; break;
        case 3 : str = "estimate_color_ID"; break;
        case 4 : str = "estimate_quantity"; break;
        case 5 : str = "estimate_high_status"; break;
        case 6 : str = "estimate_construction_reservation_pay"; break;
        default : str = "estimate_ID";
    }
    const url = `${API_URL}/reservation/select_cart_estimate_mono`;
    const data = new FormData();
    data.append('estimate_customer_ID', estimate_customer_ID.toString());
    data.append('pagination', pagination.toString());
    data.append('field', str);
    data.append('order', sort);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 견적 장바구니 아이템 삭제(status 변경)
export const delete_cart = async (
    estimate_customer_ID : number,
    estimate_ID_list     : number[]
) => {
    for (const item of estimate_ID_list) {
        item.toString();
    };

    const url = `${API_URL}/reservation/delete_cart`;
    const data = new FormData();
    data.append('estimate_customer_ID', estimate_customer_ID.toString());
    data.append('estimate_ID_list', JSON.stringify(estimate_ID_list));
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 공지사항 가져오기
export const get_notice_select = async (
    customer_ID : number,
    pagination : number
) => {
    const url = `${API_URL}/common/select_notice`;
    const data = new FormData();
    data.append('customer_ID', customer_ID.toString());
    data.append('pagination', pagination.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 포트폴리오 가져오기
export const get_portfolio_select = async (
    ablack_comunity_brand_ID : number,
    product_type_number : number,
    pagination      : number,
    query_text      : string,
    sort_number     : number,
    place_number    : string,
    including_place_unregistered: boolean,
    apply_square_meter_query: any,
) => {
    let field = "";
    switch (sort_number) {
        case 0 : field = "ablack_comunity_registe"; break;
        case 1 : field = "favorite_count"; break;
        default : field = "ablack_comunity_registe";
    };
    const url = `${API_URL}/community/select_portfolio`;
    const data = new FormData();
    data.append('ablack_comunity_brand_ID', ablack_comunity_brand_ID.toString());
    data.append('product_type_number', product_type_number.toString());
    data.append('pagination', pagination.toString());
    data.append('query_text', query_text);
    data.append('field', field);
    data.append('place_number', place_number);
    data.append('including_place_unregistered', JSON.stringify(including_place_unregistered));
    data.append('apply_square_meter_query', JSON.stringify(apply_square_meter_query) || JSON.stringify({}));

    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 예약 번호로 브랜드 / 제품 정보 가져오기
export const get_brand_with_reservation_ID = async (
    construction_reservation_ID : any
) => {
    const url = `${API_URL}/reservation/select_one_brand`;
    const data = new FormData();
    data.append('construction_reservation_ID', construction_reservation_ID);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 견적 장바구니 정보 한개 가져오기
export const get_select_one_estimate = async (
    estimate_customer_ID : number,
    estimate_ID : number
) => {
    const url = `${API_URL}/reservation/select_one_estimate`;
    const data = new FormData();
    data.append('estimate_customer_ID', estimate_customer_ID.toString());
    data.append('estimate_ID', estimate_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 나의 커뮤니티 작성내역 가져오기
export const get_select_my_community = async (
    ablack_comunity_customer_ID : number,
    pagination : number,
    list_count : number,
    field : number,
    order : number
) => {
    let sort = "";
    if(order === 0) {
        sort = "DESC";
    } else if (order === 1) {
        sort = "ASC";
    }
    let str = "";
    switch (field) {
        case 0 : str = "ablack_comunity_ID"; break;
        case 1 : str = "ablack_comunity_division"; break;
        case 2 : str = "ablack_comunity_brand_ID"; break;
        case 3 : str = "ablack_comunity_color_ID"; break;
        case 4 : str = "ablack_comunity_review"; break;
        case 5 : str = "ablack_comunity_registe"; break;
        default : str = "ablack_comunity_ID";
    };

    const url = `${API_URL}/community/selet_my_community`;
    const data = new FormData();
    data.append('ablack_comunity_customer_ID', ablack_comunity_customer_ID.toString());
    data.append('pagination', pagination.toString());
    data.append('list_count', list_count.toString());
    data.append('field', str);
    data.append('order', sort);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 커뮤니티 게시물 하나 가져오기
export const get_select_one_community = async (
    ablack_comunity_ID : number,
    ablack_comunity_customer_ID : number
) => {
    const url = `${API_URL}/community/select_one_community`;
    const data = new FormData();
    data.append('ablack_comunity_ID', ablack_comunity_ID.toString());
    data.append('ablack_comunity_customer_ID', ablack_comunity_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

export const get_select_one_portfolio_favorite = async (
    ablack_comunity_ID : number,
    ablack_comunity_customer_ID : number
) => {
    const url = `${API_URL}/community/get_select_one_portfolio_favorite`;
    const data = new FormData();
    data.append('ablack_comunity_ID', ablack_comunity_ID.toString());
    data.append('ablack_comunity_customer_ID', ablack_comunity_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 포트폴리오 즐겨찾기 추가하기
export const insert_favorite_portfolio = async (
    ablack_comunity_favorite_comunity_ID : number,
    ablack_comunity_favorite_customer_ID : number
) => {
    const url = `${API_URL}/community/insert_favorite_portfolio`;
    const data = new FormData();
    data.append('ablack_comunity_favorite_comunity_ID', ablack_comunity_favorite_comunity_ID.toString());
    data.append('ablack_comunity_favorite_customer_ID', ablack_comunity_favorite_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 포트폴리오 즐겨찾기 삭제하기
export const delete_favorite_portfolio = async (
    ablack_comunity_favorite_comunity_ID : number,
    ablack_comunity_favorite_customer_ID : number
) => {
    const url = `${API_URL}/community/delete_favorite_portfolio`;
    const data = new FormData();
    data.append('ablack_comunity_favorite_comunity_ID', ablack_comunity_favorite_comunity_ID.toString());
    data.append('ablack_comunity_favorite_customer_ID', ablack_comunity_favorite_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 나의 좋아요 community_ID 리스트
export const select_favorite_portfolio_ID_list = async (
    ablack_comunity_favorite_customer_ID : number
) => {
    const url = `${API_URL}/community/select_favorite_portfolio_ID_list`;
    const data = new FormData();
    data.append('ablack_comunity_favorite_customer_ID', ablack_comunity_favorite_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 내가 좋아요 한 포트폴리오 리스트 가져오기
export const select_favorite_portfolio = async (
    ablack_comunity_favorite_customer_ID : number,
    pagination : number,
    brand_ID : number
) => {
    const url = `${API_URL}/community/select_favorite_portfolio`;
    const data = new FormData();
    data.append('ablack_comunity_favorite_customer_ID', ablack_comunity_favorite_customer_ID.toString());
    data.append('pagination', pagination.toString());
    data.append('brand_ID', brand_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 즐겨찾기 한 브랜드 리스트만 가져오기 (brand_ID)
export const select_favorite_portfolio_brand = async (
    ablack_comunity_favorite_customer_ID : number
) => {
    const url = `${API_URL}/community/select_favorite_portfolio_brand`;
    const data = new FormData();
    data.append('ablack_comunity_favorite_customer_ID', ablack_comunity_favorite_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 제품 타입 리스트 가져오기
export const get_product_type_select = async () => {
    const url = `${API_URL}/common/get_product_type_select`;
    const data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 결제 요청
export const request_payment = async (
    construction_reservation_ID : number,
    construction_reservation_pay : number,
    customer_ID : number
) => {
    const url = `${API_URL}/reservation/request_payment`;
    const data = new FormData();
    data.append('construction_reservation_ID', construction_reservation_ID.toString());
    data.append('construction_reservation_pay', construction_reservation_pay.toString());
    data.append('customer_ID', customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 포인트 사용/적립 내역 가져오기
export const get_point_transaction_list = async (
    customer_ID : number,
    pagination : number,
    field : number,
    order : number
) => {
    let sort = "";
    if(order === 0) {
        sort = "DESC";
    } else if (order === 1) {
        sort = "ASC";
    }
    let str = "";
    switch (field) {
        case 0 : str = "history_date"; break;
        case 1 : str = "point_type"; break;
        case 2 : str = "point_value"; break;
        case 3 : str = "history_memo"; break;
        case 4 : str = "history_date"; break;
        default : str = "history_date";
    };
    const url = `${API_URL}/customer/get_point_transaction_list`;
    const data = new FormData();
    data.append('customer_ID', customer_ID.toString());
    data.append('pagination', pagination.toString());
    data.append('point_type', "0");
    data.append('field', str);
    data.append('order', sort);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 예약 내역 1개 가져오기
export const get_select_one_reservation = async (
    construction_reservation_ID : number
) => {
    const url = `${API_URL}/reservation/select_one_reservation`;
    const data = new FormData();
    data.append('construction_reservation_ID', construction_reservation_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 인디케이터에 들어갈 예약내역 리스트 가져오기
export const get_select_reservation_indicator = async (
    customer_ID : number
) => {
    const url = `${API_URL}/reservation/get_select_reservation_indicator`;
    const data = new FormData();
    data.append('customer_ID', customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 나의 시공완료된 목록 가져오기
export const get_my_complete_construction_list = async (
    customer_ID: number
) => {
    const url = `${API_URL}/community/get_my_complete_construction_list`;
    const data = new FormData();
    data.append('customer_ID', customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 시공후기 삭제(상태변경)하기
export const update_portfolio_inactive_one = async (
    ablack_comunity_ID : number,
    ablack_comunity_customer_ID : number
) => {
    const url = `${API_URL}/community/update_portfolio_status`;
    const data = new FormData();
    data.append('ablack_comunity_ID', ablack_comunity_ID.toString());
    data.append('ablack_comunity_customer_ID', ablack_comunity_customer_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 포트폴리오 수정 요청
export const modify_portfolio_one = async (
    ablack_comunity_ID : number,
    ablack_comunity_customer_ID : number,
    ablack_comunity_division : number,
    ablack_comunity_brand_ID : number,
    ablack_comunity_color_ID : number,
    ablack_comunity_high_status : number,
    ablack_comunity_square_meter : number,
    ablack_comunity_space : number,
    ablack_comunity_review : string,
    origin_photo_url_list_length : number,
    origin_photo_url_list : (string | null)[],
    portfolio_photo_list : File[]
) => {
    const url = `${API_URL}/community/modify_portfolio_one`;
    let data = new FormData();
    data.append('ablack_comunity_ID', ablack_comunity_ID.toString());
    data.append('ablack_comunity_customer_ID', ablack_comunity_customer_ID.toString());
    data.append('ablack_comunity_division', ablack_comunity_division.toString());
    data.append('ablack_comunity_brand_ID', ablack_comunity_brand_ID.toString());
    data.append('ablack_comunity_color_ID', ablack_comunity_color_ID.toString());
    data.append('ablack_comunity_high_status', ablack_comunity_high_status.toString());
    data.append('ablack_comunity_square_meter', ablack_comunity_square_meter.toString());
    data.append('ablack_comunity_space', ablack_comunity_space.toString());
    data.append('ablack_comunity_review', ablack_comunity_review);
    data.append('origin_photo_url_list_length', origin_photo_url_list_length.toString());
    data.append('origin_photo_url_list', JSON.stringify(origin_photo_url_list));
    portfolio_photo_list.forEach(file => {
        data.append('portfolio_photo_list', file);
    });
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 예약 취소하기
export const cancel_reservation_one = async (
    construction_reservation_ID : number,
    customer_ID_use_construction_reservation : number,
    construction_reservation_progress : number
) => {
    const url = `${API_URL}/reservation/cancel_reservation_one`;
    let data = new FormData();
    data.append('construction_reservation_ID', construction_reservation_ID.toString());
    data.append('customer_ID_use_construction_reservation', customer_ID_use_construction_reservation.toString());
    data.append('construction_reservation_progress', construction_reservation_progress.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 예약 상세 현장 사진 수정 (2026-10-28) — 유지할 기존 URL(keep_site) + 신규 파일(site_files), 저장 후 2장 이상 4장 이하
// 백엔드 BRS_backend routes/ablack_site_photo.js (ERP 와 같은 계약). 응답 { success, site_images } | { success:false, error }
export const update_reservation_site_photos = async (
    construction_reservation_ID : number,
    customer_ID : number,
    keep_urls : string[],
    new_files : File[]
) : Promise<{ success: boolean; site_images?: string[]; error?: string }> => {
    const url = `${API_URL}/reservation/update_reservation_site_photos`;
    const data = new FormData();
    data.append('construction_reservation_ID', construction_reservation_ID.toString());
    data.append('customer_ID', customer_ID.toString());
    data.append('keep_site', JSON.stringify(keep_urls));
    new_files.forEach(file => {
        data.append('site_files', file);
    });
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
        return { success: false, error: '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.' };
    };
};

// qna 문의 등록
export const insert_customer_qna = async (
    ablack_ask_customer_ID : number,
    ablack_ask_division : number,
    ablack_ask_question : string,
    ask_photo_list : File[]
) => {
    const url = `${API_URL}/about/insert_customer_qna`;
    const data = new FormData();
    data.append('ablack_ask_customer_ID', ablack_ask_customer_ID.toString());
    data.append('ablack_ask_division', ablack_ask_division.toString());
    data.append('ablack_ask_question', ablack_ask_question);
    ask_photo_list.forEach(file => {
        data.append('ask_photo_list', file);
    });
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 문의 리스트
export const get_qna_list = async (
    ablack_ask_customer_ID : number,
    pagination : number
) => {
    const url = `${API_URL}/about/get_qna_list`;
    const data = new FormData();
    data.append('ablack_ask_customer_ID', ablack_ask_customer_ID.toString());
    data.append('pagination', pagination.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 1:1 문의 한개 조회
export const get_qna_select_one = async (
    ablack_ask_customer_ID : number,
    ablack_ask_ID : number,
) => {
    const url = `${API_URL}/about/get_qna_select_one`;
    const data = new FormData();
    data.append('ablack_ask_customer_ID', ablack_ask_customer_ID.toString());
    data.append('ablack_ask_ID', ablack_ask_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 견적 memo 업데이트(추가) 
export const update_estimate_memo = async (
    estimate_customer_ID : number,
    estimate_ID : number,
    estimate_memo : string
) => {
    const url = `${API_URL}/reservation/update_estimate_memo`;
    const data = new FormData();
    data.append('estimate_customer_ID', estimate_customer_ID.toString());
    data.append('estimate_ID', estimate_ID.toString());
    data.append('estimate_memo', estimate_memo);
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// FAQ 목록 가져오기
export const get_faq_by_division = async (
    ablack_faq_division : number
) => {
    const url = `${API_URL}/about/get_faq_by_division`;
    const data = new FormData();
    data.append('ablack_faq_division', ablack_faq_division.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

// 공지사항 하나 가져오기
export const get_select_one_notice = async (
    ablack_notice_ID : number
) => {
    const url = `${API_URL}/about/get_select_one_notice`;
    const data = new FormData();
    data.append('ablack_notice_ID', ablack_notice_ID.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

export const get_popup_notice = async () => {
    const url = `${API_URL}/about/get_popup_notice`;
    const data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

export const get_reservation_detail_for_excel = async (
    customer_ID_use_construction_reservation: number,
) => {
    const url = `${API_URL}/reservation/get_reservation_detail_for_excel`;
    const data = new FormData();
    data.append("customer_ID_use_construction_reservation", customer_ID_use_construction_reservation.toString());
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};

export const get_integrated_construction_list = async () => {
    const url = `${API_URL}/reservation/get_integrated_construction_list`;
    const data = new FormData();
    const reqHeader = {
        headers : {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };
    try {
        const response = await axios.post(url, data, reqHeader);
        return response.data;
    }
    catch (err) {
        console.log(err);
    };
};